export function isSubNavigationA(item) {
    const children = item.children;
    return !!children && children !== null && children.length > 1;
}
